(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationParameterController', CommunicationParameterController);

    CommunicationParameterController.$inject = ['CommunicationParameter'];

    function CommunicationParameterController(CommunicationParameter) {

        var vm = this;

        vm.communicationParameters = [];
        var loaded = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            CommunicationParameter.query(function(result) {
                loaded = result;
                vm.communicationParameters = result;
                vm.searchQuery = null;
                vm.currentSearch = null;
            });
        }

        function search() {
        if (!vm.searchQuery) {
            vm.communicationParameters = loaded;
            vm.currentSearch = null;
            return;
        }
        /* There is no search endpoint for this entity. The XSearch service this used to call was
           JHipster Elasticsearch scaffolding that this application never had - injecting it threw
           "Unknown provider", which killed the whole controller, so the page rendered NOTHING at
           all. The list is loaded in full above, so the box filters what is already here. */
        var needle = String(vm.searchQuery).toLowerCase();
        vm.communicationParameters = loaded.filter(function(item) {
            return Object.keys(item).some(function(key) {
                var value = item[key];
                return value !== null && value !== undefined && typeof value !== 'object' &&
                    String(value).toLowerCase().indexOf(needle) !== -1;
            });
        });
        vm.currentSearch = vm.searchQuery;
        }

        function clear() {
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.communicationParameters = loaded;
        }
    }
})();
